<template>
	<div id="about">
		<myhead></myhead>
    <div class="bar">
	  	<router-link to="/">Fountain-scientific Home Page</router-link>
      	<span>></span>
      <router-link to="/about">About US</router-link>
		</div>
		<div class="main">
      <div class="left">
        <p class="left-p" @click="changeCurIndex(0)"
         :class="curIndex == 0?'left-active':''">Company Profile</p>
        <!-- <p @click="changeCurIndex(1)" :class="curIndex == 1?'left-active':''">配送范围</p> -->
      </div>
      <div class="division">
        <img src="../assets/imgs/division.png">
      </div>
      <div class="right">
        <!-- <div class="h">
          <div class="redtri"></div>
          <span v-show="curIndex == 0">Company Profile</span>
          <span v-show="curIndex == 1">配送范围</span>
        </div> -->
        <div class="content">
          <div class="intro" v-show="curIndex == 0">
            <!-- <p class="big-title">
              我们拥有许多专业优势！
            </p>
            <p class="intro-p">
              热泉科技全体员工秉持着为生命，为科学理念，怀抱最大的诚意，与客户携手前行。
            </p> -->
            <p class="intro-title">
              About Guangzhou Fountain Scientific Co., Ltd.
            </p>
            <p class="intro-p">A best house designer is not just designing houses to live, but creating a life style for people. A best entrepreneurse is not just a products producer, but a designer to create a new work style for the industrial users, and eventualy for its people involved. What Fountain Scientific doing is to help laboratory business suplier to build their own product and service brand by providing the high quality products with a fair-enough price. How we do that? We believe we should do six things, that are, Focus,Serial,Professional,Team,Mass production,and finally we have ‘small market, big share ’ vision. If you have interest in becoming our country distributor or you need us to OEM for you, welcome to make a contact with us.
            </p>
            <p class="intro-title">
              Quality is what we are focusing
            </p>
            <p class="intro-p">
              The quality control lab with a area of 100m² is undertaking the products sterility test, pyrogenic test, the size and weight test, the particles test, and the pakage materials test.
            </p>

            <p class="intro-title">
              Clean environment and high-speed producing
            </p>
            <p class="intro-p">
              700m² Class 100,000 clean room, with high-speed injection molding machines sutable for high quality plastic consumables producing. There is no evidence of contamination in regular test of the innitial bioburden of products without radiation sterillizing, since the production and quality control are performed strictly in accordance with corresponding SOP.
            </p>
            <!-- <p class="intro-title">
              预备测试、准确定位
            </p>
            <p class="intro-p">
              为了帮助用户寻找最适用的商品，对于使用频次较高的消耗品，
              热泉科技无偿提供试用样品作为客户购买前的参考；对于机器，
              亦可提供样机现场测试或用户寄样品远程样机测试服务，
              让客户能对产品的功能、操作性等进行充分的确认。
            </p>
            <p class="intro-title">
              最小起定量  
            </p>
            <p class="intro-p">
              支持单个起订，货期也非常短，即使是一个烧杯，也是热泉科技尊贵的客户。
            </p>       
            <p class="intro-title">
              技术支持 
            </p>
            <p class="intro-p">
              交货时提供产品的说明和技术上的支援，
              如安装培训、使用培训等。在确保客户能完全独自使用前，热泉科技不敢有丝毫松懈。
            </p>   
            <p class="intro-title">
              包退包换 
            </p>
            <p class="intro-p">
             如发现有质量或功能如声称的不一致，以及运输过程中产生的破损，
             我们将在一个星期之内进行退换处理，除非是定制及进口产品，则时间待定。
            </p>    -->
            <!-- <div class="box">
              <p class="box-title">
                <img src="../assets/imgs/about-logo.png">
              </p>  
              <div class="box-intro">
                <img src="" alt="">
                <div class="box-img">
                  <img src="../assets/imgs/about.png">
                </div>
                <div class="box-t">
                  <p>热泉科技（原热泉港生物）创立于2015年，坐落于环境优美的广州黄埔区，占地面积约1600m²。</p>
                  <p>热泉科技是一家专门从事生命科学实验室高端耗材的研发、生产、销售、代加工的企业，主要产品为生物培养、液体处理和定制化产品三大类产品和服务，产品数量多达500多种，涉及食品、药品、日化、科研、体外诊断、临床试验等多个应用领域。公司产品主要销往全世界20多个国家和地区，凭借优越的性能和个性化定制，以及高效的服务成功进入生物实验室综合服务商的全球供应链体系。热泉科技服务的优秀实验室已经多达1000家。</p>
                  <p>我们的宗旨是为生命科学研究者提供安全、准确、高效、经济的实验用品。通过提供良好的实验条件，帮助每一位生命科学工作者成功。</p>
                </div>
              </div>
            </div>                                                     -->
          </div>
          <div class="range" v-show="curIndex == 1">
            <img src="../assets/imgs/range.jpg">
          </div>
        </div>
      </div>
    </div>


	</div>
</template>

<script>
import myhead from "./common/header.vue";
export default {
  name: "About",
  components: {
    myhead
  },
  data() {
    return {
      //控制tab切换，0->公司简介，1->配送范围
      curIndex:0
    };
  },
  methods: {
    changeCurIndex(i){
      this.curIndex = i;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../assets/css/style.less");

.bar{
  height: 30px;
  line-height: 30px;
  text-align: left;
  font-size: 14px;
  padding: 0 10%;
  margin: 20px 0;
}
.bar>span{
  margin: 0 10px;
}
.main{
  padding: 0 10%;
  display: flex;
  text-align: left;
}
.left{
  border-top: 1px #ddd solid;
  font-size: 16px;
  width: 230px;
  min-height: 750px;
  text-align: right;
  padding-top: 50px;
  padding-right: 15px;
}
.left-p{
  margin-bottom: 43px;
}
.left>p:hover{
  text-decoration: underline;
  color: @indexTheme;
}
.left-active{
  color: @indexTheme;
  font-weight: 600;
}
.division{
  border-top: 1px #ddd solid;
}
.right{
  padding-top:50px; 
  border-top: 1px #ddd solid;
  width: 845px;
  padding-left: 100px;
}
.h{
  background-color: black;
  color: #ddd;
  font-size: 15px;
  height: 35px;
  line-height: 35px;
}
.big-title{
  color: @indexTheme;
  font-size: 21px;
  font-weight: bold;
  padding: 7px 10px;
}
.intro-title{
  /* color: #e70012;
  font-weight: 600;
  padding: 4px 20px;
  margin: 7px 0;
  border: 1px dashed #009845; */
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  margin-top: 20px;
}
.intro-p{
  font-size: 20px;
  margin: 0 10px;
  line-height: 1.5;
}
.box{
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #eaeaea;
  padding: 20px 20px;
}
.box-title{
  font-weight: 600;
  font-size: 18px;
}
.box-title > img{
  height: 80px;
  margin: -40px -15px;
}

.box-intro{
  display: flex;
  margin-top: 10px;
}
.box-img>img{
  width: 100px;
  height: 100px;
}
.box-t{
  font-size: 14px;
  /* width: 650px; */
  /* padding-left: 20px; */
  line-height: 1.5;
}
.box-t p{
  text-indent: 2rem;
}
.range{
  padding: 20px 20px;
}
.range>img{
  width: 761px;
}
.redtri{
  float: left;
  margin-right: 15px;
  border-top-width: 14px;
  border-right-width: 12px;
  border-bottom-width: 20px;
  border-left-width: 14px;
  border-style:solid;
  border-color:@indexTheme transparent transparent @indexTheme;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue